export const FILE_TYPE = {
    id: 'users',
    name: 'Registros Localizaciones',
    uploadText: 'Arrastra y suelta el archivo Excel con datos de registros'
  };
  
  export const ALLOWED_EXCEL_TYPES = [
    'application/vnd.ms-excel', 
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  
  export const EXCEL_READ_OPTIONS = { 
    cellDates: true,
    cellStyles: true,
    cellNF: true,
    type: 'array'
  };
  
  export const THUMBNAIL_SAMPLE_SIZE = 8192; // 8KB
  export const MODAL_CLOSE_TIMEOUT = 300;
  export const PROCESS_CHUNK_SIZE = 1000; // Tamaño de los lotes para procesar datos
  export const BATCH_SIMULATION_COUNT = 5; // Número de lotes para la simulación de la consola